import { render, staticRenderFns } from "./OrderController.vue?vue&type=template&id=f46e0f48&scoped=true&"
import script from "./OrderController.vue?vue&type=script&lang=js&"
export * from "./OrderController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46e0f48",
  null
  
)

export default component.exports